import {Injectable} from '@angular/core';
import * as XLSX from 'xlsx-js-style';
import {WorkSheet} from 'xlsx-js-style';
import {JSON2SheetOpts} from 'xlsx';
import {ListViewColumn} from "./list-view.component";
import moment from "moment-timezone";

@Injectable({
  providedIn: 'root',
})
export class ListViewExportService<T> {

  private fileName = (pageTitle: string): string => {
    const dateString = moment(new Date().getTime()).format('yyyy-MM-DD');
    return `${pageTitle}_export_${dateString}`;
  }

  private exportSheet(data: T[], pageTitle: string, format: 'xlsx' | 'csv', options: JSON2SheetOpts, exportColumns: ListViewColumn<T>[] = []): void {

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, options);
    this.formatCells(ws, exportColumns);


    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, `${this.fileName(pageTitle)}.${format}`);
  }

  private formatCells(ws: WorkSheet, exportColumns: ListViewColumn<T>[]) {
    for (var i in ws) {
      if (typeof ws[i] != 'object') continue;
      let cell = XLSX.utils.decode_cell(i);

      ws[i].s = {
        // styling for all cells
        font: {
          name: 'arial',
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
          wrapText: '1', // any truthy value here
        },
        border: {
          right: {
            style: 'thin',
            color: '000000',
          },
          left: {
            style: 'thin',
            color: '000000',
          },
        },
      };

      if (exportColumns != null && exportColumns.length > 0) {
        const column = exportColumns[cell.c];

        if (column) {
          if (column.type === 'datetime') {
            ws[i].s.numFmt = 'YYYY-MM-DD HH:mm'; // for dates
            ws[i].z = 'YYYY-MM-DD HH:mm';
          } else if (column.type === 'date' || column.customAttributeFieldType == "DATE_PICKER_FIELD") {
            ws[i].s.numFmt = 'YYYY-MM-DD'; // for dates
            ws[i].z = 'YYYY-MM-DD';
          } else if (column.type === 'time') {
            ws[i].s.numFmt = 'HH:mm'; // for dates
            ws[i].z = 'HH:mm';
          } else {
            ws[i].s.numFmt = '00'; // other numbers
          }
        }
      }


      if (cell.r == 0) {
        // first row
        ws[i].s.border.bottom = {
          // bottom border
          style: 'thin',
          color: '000000',
        };
      }

      if (cell.r % 2) {
        // every other row
        ws[i].s.fill = {
          // background color
          patternType: 'solid',
          fgColor: {rgb: 'b2b2b2'},
          bgColor: {rgb: 'b2b2b2'},
        };
      }

    }
  }

  public exportAsExcel(data: T[], pageTitle: string, options = {}, exportColumns : ListViewColumn<T>[] = []): void {
    this.exportSheet(data, pageTitle, 'xlsx', options, exportColumns);
  }

  public exportAsCsv(data: T[], pageTitle: string, options = {}): void {
    this.exportSheet(data, pageTitle, 'csv', options);
  }
}
